import { CollapsiblePanel } from 'cpool-components/general/CollapsiblePanel';

import { AdditionalInformationForm } from './AdditionalInformation';
import { CarInformationForm } from './CarInformation';

export const CarFinanceForms = ({ isOpen }: { isOpen: boolean }) => {
    return (
        <CollapsiblePanel isOpen={isOpen}>
            <CarInformationForm />
            <AdditionalInformationForm />
        </CollapsiblePanel>
    );
};
